import React from "react";
import ReactDom from "react-dom";
import {ProductList} from "./pages/product_list";
import {createRoot} from "react-dom/client";

const product_page_content = document.getElementById("product_page_content");
if(product_page_content){
    const root = createRoot(product_page_content);
    root.render(<ProductList/>);
} else {
    console.log("Product page content HTML element not found!");
}